import { transactionService } from "@/common/api.service";

/**
 * Holds store module (namespaced as `holds`).
 *
 * Talks to the arch backend (`VUE_APP_ARCH_BASE_URL`, i.e. /api/v1) which proxies
 * the wallet SDK. The backend is the single source of truth — this module keeps no
 * derived hold state beyond the current page of results.
 *
 * Actions resolve with the raw axios response (success OR error response) following
 * the existing transaction module convention, so components can branch on
 * `response.status` without a try/catch.
 */
const state = {
  loading: false,
};

const getters = {
  holdsLoading(state) {
    return state.loading;
  },
};

const SET_LOADING = "SET_LOADING";

const actions = {
  // GET /api/v1/holds?<query>
  async fetchHolds(context, query = "") {
    transactionService.init();
    context.commit(SET_LOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`holds${query}`)
        .then((data) => {
          context.commit(SET_LOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_LOADING, false);
          resolve(response);
        });
    });
  },

  // POST /api/v1/holds/:holdId/confirm  — body carries idempotency_key only on Retry
  async confirmHold(context, { holdId, idempotency_key } = {}) {
    transactionService.init();
    context.commit(SET_LOADING, true);
    const body = idempotency_key ? { idempotency_key } : {};
    return new Promise((resolve) => {
      transactionService
        .post(`holds/${holdId}/confirm`, body)
        .then((data) => {
          context.commit(SET_LOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_LOADING, false);
          resolve(response);
        });
    });
  },

  // POST /api/v1/holds/:holdId/reverse — symmetric to confirm
  async reverseHold(context, { holdId, idempotency_key } = {}) {
    transactionService.init();
    context.commit(SET_LOADING, true);
    const body = idempotency_key ? { idempotency_key } : {};
    return new Promise((resolve) => {
      transactionService
        .post(`holds/${holdId}/reverse`, body)
        .then((data) => {
          context.commit(SET_LOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_LOADING, false);
          resolve(response);
        });
    });
  },
};

const mutations = {
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
